import { Message } from 'element-ui';

const errorTips = (text) => {
  Message({
    message: text,
    type: 'error',
    showClose: true,
    duration: 5000
  })
}

export default errorTips;



// WEBPACK FOOTER //
// ./src/untils/message/index.js